/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-12 16:13.
 */
const Server = require( 'helper/server' );
const ImgUpload = require( 'helper/img-upload' );

const memberatlas = Handlebars.templates[ 'purchasing-federation/member-info/templates/memberatlas' ];

const MemberAtlas = {
  async init() {
    const spiner = this.$el.find( '.block__content' ).spin();
    try {
      const data = await Server.getMemberAtlas();
      const html = memberatlas( { DATA: data || [] } );
      this.$el.find( '.info-wrap' ).html( html );
      const atlas = $( '.memberatlas .atlas-item' );
      if (atlas.length >= 6) {
        $( '#atlas-form' ).hide();
      } else {
        $( '#atlas-form' ).show();
      }
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    spiner.stop();
  },
  fileChange( e ) {
    // const file = e.target.files[ 0 ];
    const { size, name } = ImgUpload.getFileSize( e );
    const fileName = name.substr( name.lastIndexOf( '.' ) ).toUpperCase();
    if (fileName !== '.PNG' && fileName != '.JPG' && fileName !== '.JPEG') {
      alert( '图片限于png,jpeg,jpg格式' );
      $form[ 0 ].reset();
      return false;
    }
    const $form = this.$el.find( '#atlas-form' );
    // $form[ 0 ].reset();
    $form.ajaxSubmit( {
      type: 'post',
      url: Server.urls.upload,
      contentType: 'application/json',
      dataType: 'json',
      iframeTarget: '#myFrame',
      success: ( data ) => {
        $form[ 0 ].reset();
        MemberAtlas.addMemberAtlas.apply( this, [ data, $form ] );
      },
      error: ( msg ) => {
        $form[ 0 ].reset();
        alert( msg.responseText || '未知错误' );
      }
    } );
  },
  // 添加会员图册
  addMemberAtlas( data, $form ) {
    const spiner = this.$el.find( '.block__content' ).spin();
    const { original: name, url, type: suffix, id } = data;
    Server.addMemberAtlas( {
      name,
      url,
      suffix
    } ).then( res => {
      spiner.stop();
      if (res == 1) {
        // FIXME 2019-08-15 <枯荣> 上传、添加成功， 不应该调用MemberAtlas.init方法获取图片ID，需优化（后端）
        // const html = `
        //   <li class="atlas-item" data-id="${ id }">
        //     <p class="atlas-item-header" style="display: none">封面</p>
        //     <img src="${ url }?x-oss-process=image/quality,Q_75" alt="${ name }">
        //     <p class="atlas-item-bottom">
        //     <span class="set-as-cover">设为封面</span>
        //     <span class="del-atlas">删除</span>
        //   </p>
        // </li>`;
        // this.$el.find( '.atlas' ).append( html );
        MemberAtlas.init.apply( this );
      }
    }, ( err ) => {
      spiner.stop();
    } );
  },

  // 设为封面
  setAsCover( e ) {
    const spiner = this.$el.find( '.block__content' ).spin();
    const el = e.target || e.srcElement;
    const $el = $( el );
    const { id } = $el.parents( 'li' ).data();
    Server.setAsCover( { id } ).then( res => {
      spiner.stop();
      if (res) {
        const $clone = $el.parents( '.atlas-item' ).clone();
        $el.parents( '.atlas' ).find( '.atlas-item-header' ).hide();
        $clone.find( '.atlas-item-header' ).show();
        $el.parents( '.atlas' ).prepend( $clone );
        $el.parents( '.atlas-item' ).remove();
      }
    }, () => {
      spiner.stop();
    } );

  },

  // 删除会员图册
  delAtlas( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    const { id } = $el.parents( 'li' ).data();
    ZCY.utils.modal( {
      button: [ '确认', '取消' ],
      type: 'confirm',
      cls: 'as-modal',
      container: $( '.memberatlas' ),
      content: [ '确认删除?' ],
      confirm: ( $modal ) => {
        Server.deleteMemberAtlas( { id } ).then( ( res ) => {
          const success = res;
          $modal.modal( 'hide' );
          ZCY.utils.modal( {
            type: success ? 'success' : 'error',
            button: [ '确定' ],
            cls: 'as-modal',
            container: $( '.memberatlas' ),
            content: [ `删除${ success ? '成功' : '失败' }` ]
          } );
          if (success) {
            this.$el.find( `.atlas-item[data-id='${ id }']` ).remove();
            const atlas = $( '.memberatlas .atlas-item' );
            if (atlas.length >= 6) {
              $( '#atlas-form' ).hide();
            } else {
              $( '#atlas-form' ).show();
            }
          }
        }, () => {
          $modal.modal( 'hide' );
          ZCY.utils.modal( {
            type: 'error',
            cls: 'as-modal',
            button: [ '确定' ],
            container: $( '.memberatlas' ),
            content: [ `删除失败` ]
          } );
        } );
      }
    } );
  }
};

module.exports = MemberAtlas;
